import React, { useState, useCallback, useEffect } from 'react';
import FormField from './FormField';
import parsePhoneNumber from 'libphonenumber-js';
import { useIntl } from 'react-intl';
import { InputGroupAddon } from 'reactstrap';
import classnames from 'classnames';
import { debounce } from 'debounce';

const TelFormField = ({
  propertyName,
  object,
  messageId,
  hidden,
  groupClassName,
  value,
  country,
  onChange,
  ...props
}) => {
  const intl = useIntl();
  const [foundCountry, setFoundCountry] = useState(intl.locale?.toLowerCase());
  const [inputValue, setInputValue] = useState(value);

  const determinedCountry =
    country || foundCountry === 'en' ? 'us' : foundCountry || 'xx';

  const handleInputChange = (value) => {
    setInputValue(value);
    debouncedOnChange(value);
  };

  useEffect(() => {
    if (object && propertyName) {
      const initialValue = object[propertyName];
      if (initialValue) {
        handleInputChange(object[propertyName]);
      }
    }
  }, [object]);

  const debouncedOnChange = useCallback(
    debounce((value) => {
      const parsed = parsePhoneNumber(value, determinedCountry.toUpperCase());
      if (parsed) setFoundCountry(parsed.country?.toLowerCase());
      if (onChange) onChange(parsed?.number);
    }, 350),
    [determinedCountry],
  );

  return (
    <FormField
      groupClassName={classnames(
        'tel-form-field',
        'input-group',
        groupClassName,
      )}
      autocomplete="tel"
      propertyName={propertyName}
      object={object}
      messageId={messageId || 'phone_number'}
      hidden={hidden}
      value={inputValue}
      onChange={(e) => handleInputChange(e.target.value)}
      validate={{ minLength: { value: 3 } }}
      preChildren={
        <InputGroupAddon className="border" addonType="prepend">
          <img
            alt="Flag"
            className="img-cover-center"
            src={`/assets/icons/country-flags/${determinedCountry.toLowerCase()}.svg`}
          />
        </InputGroupAddon>
      }
      {...props}
    />
  );
};

export default TelFormField;
